/**
 * @generated SignedSource<<28bbb62809ff2857c856b712d7affbb7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DialogButtonTeams_teams$data = ReadonlyArray<{
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"DialogButtonTeamsDetail_team">;
  readonly " $fragmentType": "DialogButtonTeams_teams";
}>;
export type DialogButtonTeams_teams$key = ReadonlyArray<{
  readonly " $data"?: DialogButtonTeams_teams$data;
  readonly " $fragmentSpreads": FragmentRefs<"DialogButtonTeams_teams">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "DialogButtonTeams_teams",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DialogButtonTeamsDetail_team"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "87f948357abe269f50861360cd061fc1";

export default node;
